import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { IModifierGroupContext, ModifierGroupContext } from '../../modifierGroupState/modifierGroupContext';
import { List } from './List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './ModifierGroups.module.scss';

export const ModifierGroupsList: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, modifierGroups, currentPage, countOfItems } =
		useContext<IModifierGroupContext>(ModifierGroupContext);

	return (
		<>
			{modifierGroups.modifierGroupsCount ? (
				<div className={style.container} data-test="ModifierGroupsList">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={modifierGroups.modifierGroupsCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};
